
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface PlatformLogoSkeletonProps {
  className?: string;
}

export const PlatformLogoSkeleton = ({ className = "h-12 w-12" }: PlatformLogoSkeletonProps) => (
  <div className={`${className} overflow-hidden rounded-lg border border-border bg-background flex items-center justify-center`}>
    <Skeleton className="h-8 w-8 rounded-md bg-muted/80" />
  </div>
);
